<template>
  <!-- <div class="full-width" style="height:50px"> -->
  <div class="full-width">
    <div
      class="col-12 header justify-center items-center flex text-center bg-white"
    >
      <q-btn
        flat
        @click="onLeftClick"
        class="btn-header"
        style="left: 5px; position: absolute"
        round
      >
        <i class="fas fa-chevron-left"></i>
      </q-btn>
      <h4 class>{{ centerSlot }}</h4>
      <q-btn
        v-if="rightSlot"
        flat
        @click="onRightClick"
        class="btn-header"
        style="right: 5px; position: absolute"
        round
      >
        {{ rightSlot }}
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ["left-slot", "right-slot", "center-slot"],
  methods: {
    onRightClick() {
      this.$emit("on-right");
    },
    onLeftClick() {
      this.$router.go(-1);
      //   this.$emit('on-left')
    },
  },
};
</script>

<style scoped>
.header {
  /* -moz-box-sizing: content-box; */
  /* box-sizing: content-box; */
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 50px !important;
  right: 0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);
  /* padding: 5px; */
}
h4 {
  margin: 0px;
  font-size: 1.125rem;
}
</style>
